import type { CSSProperties } from 'react';

import './working-dots.css';

import { cn } from '@/lib/utils';

const DOTS = Array.from({ length: 9 }, (_, cell) => ({
  cell,
  diagonal: Math.floor(cell / 3) + (cell % 3),
}));

type WorkingDotsProps = {
  label?: string;
  ariaLabel?: string;
  className?: string;
};

/** 3×3 dot grid with a diagonal wave, used as the app's small loading indicator. */
export function WorkingDots({ label, ariaLabel, className }: WorkingDotsProps) {
  return (
    <span className={cn('inline-flex items-center text-muted-foreground', className)}>
      <span
        role="status"
        aria-label={ariaLabel ?? label ?? 'Loading'}
        data-testid="working-dots"
        className="working-dots grid grid-cols-[repeat(3,2.5px)] gap-[1.25px]"
      >
        {DOTS.map(({ cell, diagonal }) => (
          <i
            key={cell}
            className="size-[2.5px] rounded-[0.35px] bg-current"
            style={{ '--diagonal': diagonal } as CSSProperties}
          />
        ))}
      </span>
      {label && <span className="ml-2">{label}</span>}
    </span>
  );
}
